<template>
    <span>
        <Input
            type="password"
            v-model="buffer"
            :placeholder="definition.instructions"
        >
        </Input
    ></span>
</template>

<script>
export default {
    props: {
        definition: Object,
        value: String,
    },
    data() {
        return {
            buffer: this.value,
        };
    },
    watch: {
        buffer() {
            this.$emit("input", this.buffer);
        },
        value() {
            this.buffer = this.value;
        },
    },
};
</script>
